import React, { Component, Fragment } from 'react'

import { connect } from 'react-redux'
import * as actions from '../../../../../../../store/actions/index'
// import React, { Fragment } from 'react'
// import withTranslate from 'react-redux-multilingual/lib/withTranslate'
import Grid from '@material-ui/core/Grid'
import ActionPlan from '../../../../../../../containers/PageContent/Appraisal/AppraisalResult/ActionPlan/ActionPlan'
import Modal from '../../../../../../UI/Modal/Modal'
import { ResponsiveBullet } from '@nivo/bullet'
// import { connect } from 'react-redux'
import { withTranslate } from 'react-redux-multilingual'
import Typography from '@material-ui/core/Typography'
class ActionPlansModal extends Component {
  render() {
    const dataBullet = [
      {
        id: 'dataBullet',
        ranges: this.props.actionPlan?.end_value || [0],
        measures: [+this.props.actionPlan?.percent_achievement || 0],
        markers: [100]
      }
    ]
    const addHeader = (
      <Grid xs={12} item style={{ backgroundColor: '#f2faff' }}>
        <Grid container spacing={2} justify='space-around'>
          <Grid item xs={12} md={7}>
            <Grid container spacing={2} direction='column' alignItems='flex-start'>
              <Grid item>
                <Typography variant='subtitle1'>
                  {this.props.translate('organization')}: {this.props.actionPlan?.org_name}
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant='subtitle1'>
                  {this.props.translate('kpiName')}: {this.props.actionPlan?.item_name}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={1}>
            <Grid container spacing={2} direction='column'>
              <Grid item>
                <Typography variant='subtitle1'>{this.props.translate('actual')}</Typography>
              </Grid>
              <Grid item>
                <Typography variant='subtitle1'>{this.props.actionPlan?.actual_value}</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={1}>
            <Grid container spacing={2} direction='column'>
              <Grid item>
                <Typography variant='subtitle1'>{this.props.translate('target')}</Typography>
              </Grid>
              <Grid item>
                <Typography variant='subtitle1'>{this.props.actionPlan?.target_value}</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={3}>
            <Grid container spacing={2} direction='column'>
              <Grid item>
                <Typography variant='subtitle1'>
                  {this.props.translate('percentAchievement')}
                </Typography>
              </Grid>
              <Grid item style={{ minWidth: '250px' }}>
                <div style={{ widht: '20px', height: '40px' }}>
                  <ResponsiveBullet
                    data={dataBullet}
                    margin={{ top: 0, right: 9, bottom: 25, left: 3 }}
                    spacing={20}
                    titleAlign='start'
                    titleOffsetX={-55}
                    measureSize={0.25}
                    markerSize={1}
                    animate={false}
                    motionStiffness={20}
                    motionDamping={12}
                    measureColors={'black'}
                    markerColors={'white'}
                    rangeColors={this.props.actionPlan?.color_code}
                  />
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    )
    // if (this.props.) {
    //   form = (
    //     <ActionPlan
    //       closeModal={() => this.props.closeModalActionHandler()}
    //       resultItemId={this.props.resultItemId}
    //       resultId={this.props.resultId}
    //       appraisalInfo={this.props.appraisalInfo}
    //       //   setData={value => setData(value)}
    //     />
    //   )
    // }
    return (
      <Fragment>
        <Modal
          size={'xl'}
          open={this.props.modalOpen}
          onHide={() => this.props.closeModalActionHandler()}
          header={this.props.translate('actionPlan')}
          addHeader={addHeader}
          buttonClose={true}
          footer={null}
          overflow={false}>
          <ActionPlan
            closeModal={() => this.props.closeModalActionHandler()}
            resultItemId={this.props.resultItemId}
            resultId={this.props.resultId}
            appraisalInfo={this.props.appraisalInfo}
          />
        </Modal>
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    data: state.appraisal.actionPlan,
    actionPlan: state.appraisal.actionPlanData,
    responsible: state.appraisal.responsible,
    loading: state.appraisal.loadingActionPlan
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchActionPlan: filterOptions => dispatch(actions.fetchActionPlan(filterOptions)),
    createActionPlan: filterOptions => dispatch(actions.saveActionPlan(filterOptions)),
    fetchResponsibleOptionsForAppraisal: filterOptions =>
      dispatch(actions.fetchResponsibleOptionsForAppraisal(filterOptions))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(ActionPlansModal))
